<div class="form-inline">
  <!-- Buyer selector -->
  <div class="row">
    <div class="col-md-1">
      <label class="pull-left" style="margin-right: 15px">Buyer</label>
    </div>
    <div class="col-sm-6 col-md-4 form-group mb-35">
      <ps-ui-select-dropdown
        [dropdownItems]="buyers"
        [field]="'name'"
        [enableSearch]="true"
        labelNone="Select Buyer"
        [label]="selectedBuyer?.name"
        (selectedItem)="selectBuyer($event)"
      >
      </ps-ui-select-dropdown>
    </div>
  </div>

  <div class="well" *ngIf="selectedBuyer">
    <div class="col-xs-12 flex-align buyer-header">
      <h4 class="text-uppercase text-center mar35">
        {{ selectedBuyer.name }}
      </h4>
    </div>

    <div class="row justify-content-center">
      <div class="col-md-4 col-md-offset-4 row-width">
        <div class="flex-row">
          <ps-ui-accordion class="acordion">
            <ps-ui-accordion-section [title]="'AIDA V2'">
              <div class="softlaunch-toggle-btn config-tab">
                <label class="config-name-label">Enable AIDA V2</label>
                <div class="setting-info">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                  <p style="white-space: normal">
                    Turn on AIDA V2 configuration for this buyer.
                  </p>
                </div>
                <label class="status pull-right">
                  <ps-ui-slider
                    [selected]="aidaEnabled"
                    (selectedChange)="onAidaEnabledChange($event)"
                  ></ps-ui-slider>
                </label>
              </div>

              <!-- Subsettings - only if AIDA is on -->
              <div *ngIf="aidaEnabled">
                <!-- Buyer Surveys are a Race -->
                <div class="softlaunch-toggle-btn config-tab">
                  <label class="config-name-label">
                    Buyer surveys are a race
                  </label>
                  <div class="setting-info">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <p style="white-space: normal">
                      Use this option if the buyer is generally launching the
                      survey on multiple platforms, and is focused primarily on
                      fast completion.
                    </p>
                  </div>
                  <label class="status pull-right">
                    <ps-ui-slider
                      [selected]="surveysAreRace"
                      (selectedChange)="onSurveysAreRaceChange($event)"
                    ></ps-ui-slider>
                  </label>
                </div>

                <!-- Supplier Concentration Mitigation -->
                <div class="softlaunch-toggle-btn config-tab">
                  <label class="config-name-label">
                    Supplier concentration mitigation
                  </label>
                  <div class="setting-info">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <p style="white-space: normal">
                      Use this option to programatically manage supplier
                      allocations to reduce concentration of completes to a
                      single supplier.
                    </p>
                  </div>
                  <label class="status pull-right">
                    <ps-ui-slider
                      [selected]="supplierConcentrationMitigation"
                      (selectedChange)="onSupplierConcentrationChange($event)"
                    ></ps-ui-slider>
                  </label>
                </div>

                <!-- Custom Buyer Prompt -->
                <div class="softlaunch-toggle-btn config-tab">
                  <label class="config-name-label"> Custom buyer prompt </label>
                  <div class="setting-info">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <p style="white-space: normal">
                      Place any custom instructions for the buyer that will
                      assist AIDA in providing the best possible experience.
                    </p>
                  </div>

                  <div class="form-group">
                    <textarea
                      class="form-control"
                      rows="5"
                      [(ngModel)]="customBuyerPrompt"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="text-right" style="margin-top: 15px">
                <button
                  type="button"
                  psUiButton
                  color="primary"
                  [disabled]="saving"
                  (click)="saveAidaV2()"
                >
                  {{ saving ? 'Saving...' : 'Save AIDA V2 Settings' }}
                </button>
              </div>
            </ps-ui-accordion-section>
          </ps-ui-accordion>

          <div
            *ngIf="loadingConfig"
            class="text-center"
            style="margin-top: 10px"
          >
            Loading AIDA V2 settings...
          </div>
          <div
            *ngIf="error"
            class="alert alert-danger"
            style="margin-top: 10px"
          >
            {{ error }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
